export default { build: { node: 'v14.15.4', npm: '6.14.10' }, version: '2.0.10', project: 'platform', branch: 'local', commit: 'wip' };
